'use client';

import { Accordion, AccordionDetails, AccordionSummary, Box } from '@castlery/fortress';
import { Product, Variant, WarrantyOffer } from '@castlery/modules-product-domain';
import { useCallback, useEffect, useState } from 'react';
import { ProductDimensionComfort } from './product-dimension-comfort';
import { ProductPropertyParis } from './product-property-paris';

interface ProductInfoItemProps {
  header: string;
  propertyName: keyof Product['product_properties'];
  action?: string;
  warrantyList?: WarrantyOffer[];
  expandByDefault?: boolean;
  product?: Product;
  variant?: Variant;
  onAccordionChange?: (expand: boolean) => void;
}

export const ProductInfoItem = (props: ProductInfoItemProps) => {
  const {
    header,
    propertyName,
    // 数据追踪
    // action,
    warrantyList,
    expandByDefault,
    product,
    variant,
    onAccordionChange,
    ...rest
  } = props;

  const [expand, setExpand] = useState(expandByDefault || false);

  // 检测 URL 中的 anchor 并自动展开
  useEffect(() => {
    const checkHash = () => {
      if (header === 'Dimensions' && window.location.hash === '#dimension-property') {
        setExpand(true);
      }
    };

    checkHash();

    window.addEventListener('hashchange', checkHash);

    return () => {
      window.removeEventListener('hashchange', checkHash);
    };
  }, [header]);

  const handleToggle = useCallback(
    (event: any, newValue: any) => {
      setExpand(newValue);
      onAccordionChange?.(newValue);
    },
    [onAccordionChange]
  );

  return (
    <>
      <Accordion
        onChange={handleToggle}
        divider
        expanded={expand}
        sx={{
          pt: 4,
          pb: 1,
        }}
        id={header === 'Dimensions' ? 'dimension-property' : undefined}
        {...rest}
      >
        <AccordionSummary key={header}>{header}</AccordionSummary>
        <AccordionDetails>
          <Box
            sx={{
              mt: 2,
            }}
          >
            {header === 'Dimensions' && <ProductDimensionComfort product={product} variant={variant} />}
            <ProductPropertyParis
              propertyName={propertyName}
              product={product}
              variant={variant}
              warrantyList={warrantyList}
              key={`${propertyName}-${header}`}
            />
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  );
};
